<template>
    <div class="LoadingOverlay" v-show="show">
        <div class="LoadingOverlay__text">
            <i class="fa fa-circle-o-notch fa-spin fa-fw"></i> Loading...
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                show: false,
            }
        },

        props: {
            navbar: {
                default: false,
            }
        },

        mounted() {
            bus.$on('show-loading-overlay', () => {
                this.show = true;
            });

            bus.$on('hide-loading-overlay', () => {
                this.show = false;
            });
        },
    }
</script>